import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConvertorService {
  public readonly getJsonToObj = (item: any): string => {
    if (!item) return '';
    const toString = JSON.stringify(item);
    const toJson = JSON.parse(toString);
    return toJson
  }

  public readonly setCopyOnClipboard = (item: any): void => {
    const value = JSON.stringify(item);
    navigator.clipboard.writeText(value);
  }
}
